import { useQuery, UseQueryOptions } from 'react-query';
import { getSectorTree, Block } from '~src/services/api/modules';

/**
 * React Query hook for fetching the sector tree
 *
 * Fetches the hierarchical structure: Block → Subdivision → Sector
 * Used by the Sectors browser to display the accordion navigation
 *
 * @param projectId - The project ID
 * @param options - Additional react-query options
 * @returns Query result with Block[] data
 */
export const useSectorTree = (
  projectId: string,
  options?: UseQueryOptions<Block[], Error>
) => {
  return useQuery<Block[], Error>(
    ['sector-tree', projectId],
    async () => {
      return getSectorTree({ projectId });
    },
    {
      enabled: !!projectId,
      staleTime: 5 * 60 * 1000, // Cache for 5 minutes - tree structure rarely changes
      ...options,
    }
  );
};
